// AI Generated Test
import { Component, inject, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { SessionService } from '@monsido/core/session/session.service';
import { AgreementRepoService } from '@client/app/services/api/agreement-repo/agreement-repo.service';
import { MonLoadingService } from '@monsido/services/loading/services/loading.service';
import { LoginService } from '@client/app/core/services/login/login.service';
import { CoreAgreementService } from '@monsido/core/session/services/agreement/agreement.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { Agreement } from '@monsido/modules/models/api/agreement';
import { IS_MICROFRONTEND } from '@client/mfe/tokens/mfe-tokens';
import { MfeDataService } from '@monsido/core/mfe/mfe-data.service';

@Component({
    selector: 'customer-picker',
    templateUrl: './customer-picker.component.html',
    standalone: false,
})
export class CustomerPickerComponent implements OnInit {
    showAgreements: boolean = false;
    showError: boolean = false;
    agreements: Agreement[] = [];
    search: string = '';

    private isMicrofrontend = inject(IS_MICROFRONTEND, { optional: true });
    private mfeDataService = inject(MfeDataService);

    constructor (
        private stateService: StateService,
        private sessionService: SessionService,
        private agreementRepoService: AgreementRepoService,
        private monLoadingService: MonLoadingService,
        private loginService: LoginService,
        private coreAgreementService: CoreAgreementService,
        private monEventService: MonEventService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.showAgreements = false;
        this.monLoadingService.show();
        this.agreementRepoService.getAll().then((agreementData: any) => {
            // The API returns different structure, need to handle array vs single object
            const agreements = Array.isArray(agreementData) ? agreementData : [agreementData];

            if (this.isMicrofrontend) {
                const organizationId = this.mfeDataService.getOrganizationId();

                const mfeAgreement = agreements.find(
                    (a: Agreement) => a.account.organization_uuid === organizationId,
                );
                if (mfeAgreement != null) {
                    this.loginService.getUser().then(() => {
                        this.coreAgreementService.setAgreement(mfeAgreement).then(() => {
                            this.coreAgreementService.setAgreements(agreements);
                            this.monUIRouterTransitionService.onTransitionFinished(() => {
                                this.stateService.go('base.customer.dashboard', { customerId: mfeAgreement.account.id });
                            });
                        }, () => {});
                    });
                } else {
                    this.monLoadingService.hide();
                    this.showError = true;
                }
                return;
            }

            if (agreements.length === 1) {
                this.loginService.getUser().then(() => {
                    this.coreAgreementService.setAgreement(agreements[0]).then(() => {
                        this.coreAgreementService.setAgreements(agreements);
                        this.monUIRouterTransitionService.onTransitionFinished(
                            () => {
                                this.stateService.go('base.customer.dashboard', { customerId: agreements[0].account.id });
                            },
                        );
                    }, () => {});
                });
            } else {
                this.monLoadingService.hide();
                this.showAgreements = true;
            }
            this.agreements = agreements.filter((agreement: Agreement) => {
                return agreement.support === false;
            });
        });
    }

    onSearch (search: string): void {
        this.search = search;
    }

    filterAgreements (): Agreement[] {
        return this.agreements.filter((row: Agreement) => {
            // Only show Customer type agreements
            if (row.account.type !== 'Customer') {
                return false;
            }
            // Apply search filter if search term exists
            if (this.search) {
                return row.account.name.toLowerCase().includes(this.search.toLowerCase());
            }
            return true;
        });
    }

    selectAgreement (agreement: Agreement): void {
        this.loginService.getUser().then(() => {
            this.coreAgreementService.setAgreement(agreement).then(
                async () => {
                    this.coreAgreementService.setAgreements(this.agreements);
                    await this.stateService.go('base.customer.dashboard', {
                        customerId: agreement.account.id,
                        page: 1,
                        page_size: 10,
                        sort_by: 'favorite',
                        sort_dir: 'desc',
                    }).finally(() => {
                        this.monEventService.run('setAgreementNavigationCompleted');
                    });
                },
                () => {},
            );
        });
    }
}
